import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addFavourite, clearFavourites, removeFavourite, selectFavourites, selectIsFavourite, toggleFavourite } from '../redux/features/platformSlice';

export function useFavourites() {
  const dispatch = useDispatch();
  const symbols = useSelector(selectFavourites);

  const isFavourite = useCallback(sym => symbols.includes(sym), [symbols]);
  const toggle = useCallback(sym => { dispatch(toggleFavourite(sym)); return !symbols.includes(sym); }, [dispatch, symbols]);
  const add    = useCallback(sym => dispatch(addFavourite(sym)),    [dispatch]);
  const remove = useCallback(sym => dispatch(removeFavourite(sym)), [dispatch]);
  const clear  = useCallback(()  => dispatch(clearFavourites()),    [dispatch]);

  return { symbols, isFavourite, toggle, add, remove, clear };
}

export function useIsFavourite(symbol) {
  return useSelector(selectIsFavourite(symbol));
}
